import React, { useState, useEffect } from 'react';
import { PrepAdminLayout } from '../../../components/prep/PrepAdminLayout';
import { Card, CardContent } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';
import { Button } from '../../../components/ui/button';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PrepAdminEnrollments = () => {
  const [enrollments, setEnrollments] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    axios.get(`${API}/prep/admin/enrollments`, { withCredentials: true })
      .then(r => setEnrollments(r.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const cancel = async (id) => {
    if (!window.confirm('Cancel this enrollment?')) return;
    try {
      await axios.delete(`${API}/prep/admin/enrollments/${id}`, { withCredentials: true });
      toast.success('Enrollment cancelled');
      load();
    } catch { toast.error('Failed to cancel'); }
  };

  const totalRevenue = enrollments.reduce((sum, e) => sum + (e.amount_paid || 0), 0);

  return (
    <PrepAdminLayout title="Enrollments & Payments">
      <div className="mb-6 p-4 bg-blue-50 border-2 border-blue-200 rounded-lg inline-block">
        <span className="text-sm text-gray-600">Total Revenue: </span>
        <span className="text-2xl font-bold text-blue-700">${totalRevenue.toFixed(2)}</span>
        <span className="text-sm text-gray-500 ml-2">({enrollments.length} enrollments)</span>
      </div>

      {loading ? <div className="text-center py-8 text-gray-500">Loading...</div> : (
        <div className="space-y-3">
          {enrollments.map((e) => (
            <Card key={e.id} className="border">
              <CardContent className="py-4">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="flex items-center gap-3 mb-1">
                      <span className="font-semibold text-gray-900">{e.user_name}</span>
                      <Badge className={e.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}>
                        {e.status}
                      </Badge>
                    </div>
                    <div className="text-sm text-gray-500">{e.user_email}</div>
                    <div className="text-sm text-gray-600 mt-1">
                      Program: <span className="font-medium">{e.program_title}</span>
                    </div>
                    <div className="text-xs text-gray-400 mt-1">
                      Enrolled: {e.enrolled_at ? new Date(e.enrolled_at).toLocaleDateString() : '—'}
                      {e.payment_id && ` · Payment ID: ${e.payment_id.slice(0, 20)}...`}
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="text-xl font-bold text-blue-700">${(e.amount_paid || 0).toFixed(2)}</span>
                    {e.status === 'active' && (
                      <Button size="sm" variant="outline" onClick={() => cancel(e.id)} className="text-red-600 border-red-300 hover:bg-red-50" data-testid={`cancel-enrollment-${e.id}`}>
                        Cancel
                      </Button>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
          {enrollments.length === 0 && <p className="text-center text-gray-500 py-8">No enrollments yet.</p>}
        </div>
      )}
    </PrepAdminLayout>
  );
};
